import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=5ab58c77&scoped=true"
import script from "./Prizes.vue?vue&type=script&lang=js"
export * from "./Prizes.vue?vue&type=script&lang=js"
import style0 from "./Prizes.vue?vue&type=style&index=0&id=5ab58c77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab58c77",
  null
  
)

export default component.exports